import React from 'react';
import { Box, Typography, Paper, TextField, Button, Divider } from '@mui/material';

function Settings() {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>Settings</Typography>
      
      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h6" gutterBottom>Profile Settings</Typography>
        <TextField label="Full Name" fullWidth sx={{ mb: 2 }} />
        <TextField label="Email" fullWidth disabled sx={{ mb: 2 }} />
        <Button variant="contained">Update Profile</Button>
      </Paper>

      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h6" gutterBottom>Notification Settings</Typography>
        <Typography color="textSecondary">Configure alert preferences</Typography>
      </Paper>

      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>Account</Typography>
        <Button color="error" variant="outlined">Sign Out</Button>
      </Paper>
    </Box>
  );
}

export default Settings;
